import { useMemo, useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _isNil from 'lodash/isNil';
import { IoChevronBackOutline } from 'react-icons/io5';
import { getValueFromLocalStorage } from '../../utils/common';

import { RootState } from '../../store';
import { routePathOptions } from '../../utils/contant';
import { SETTINGS_CARDS } from '../../pages/Settings';
import { IconWrapper, Text, toasts } from '../../ui-component';
import { api } from '../../utils/apiRequest';

import { Container, HeaderInfo, Circle } from './style';
interface FormData {
  admin_tailor_name: string;
  admin_tailor_profile_pic_url?: string;
  boutique_type?: string;
  boutique_name?: string;
  // ... other properties can be added as needed
}

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname, search } = location;
  const { commonDataReducer } = useSelector((state: RootState) => state);
  //const { boutiqueData } = onboardingReducer;
  // eslint-disable-next-line no-console
  //console.log('nitish', boutiqueData);
  const { enableHeaderBackButton } = commonDataReducer.headerData;

  //const { admin_tailor_profile_pic_url = '' } = boutiqueData || {};

  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState<FormData | null>(null);

  useEffect(() => {
    const getListData = async () => {
      const boutique_id = getValueFromLocalStorage('boutique_id');

      if (!_isNil(boutique_id)) {
        setIsLoading(true);
        try {
          const response = await api.getRequest(`boutique/${boutique_id}`);
          const { status, data } = response;

          if (status) {
            setListData(!_isNil(data) ? data : null);
          }
        } catch (err) {
          if (err instanceof Error) {
            toasts('error', 'Failed to fetch boutique data', 'error-boutique-data');
          }
        }
        setIsLoading(false);
      } else {
        toasts('info', 'Boutique Not Exist', 'boutique-not-exists');
      }
    };
    getListData();
  }, []);

  // eslint-disable-next-line no-console
  //console.log('Data being passed:', listData);

  const getCurrentRoute = () => {
    // First try to find an exact match
    const exactMatch = routePathOptions.find((route) => route.path === pathname);

    if (exactMatch) {
      return [exactMatch];
    }

    // Then try to find the most specific match (longest path where pathname starts with route.path)
    // This handles nested routes like /settings/items-and-categories/add-item
    // We check that the match is at a path boundary (end of string or followed by /)
    const matches = routePathOptions
      .filter((route) => {
        if (pathname === route.path) {
          return true;
        }

        if (pathname.startsWith(route.path)) {
          const nextChar = pathname[route.path.length];

          // Match if it's the end of string or followed by a path separator
          return nextChar === undefined || nextChar === '/';
        }

        return false;
      })
      .sort((a, b) => b.path.length - a.path.length);

    if (matches.length > 0) {
      return [matches[0]];
    }

    // Fallback to the old logic for backwards compatibility
    const currentPath = pathname.split('/')[1];

    return routePathOptions.filter((route) => {
      if (route.path.includes(currentPath)) {
        return true;
      }

      return false;
    });
  };

  const getHeaderTitle = useMemo(() => {
    const currentRoute = getCurrentRoute();

    if (currentRoute.length > 0) {
      const searchParams = new URLSearchParams(search.substring(1));
      const pathFormType = searchParams.get('formType') ?? '';

      if (!_isNil(currentRoute[0].formType) && !_isNil(currentRoute[0].formType[pathFormType])) {
        return currentRoute[0].formType[pathFormType];
      }

      if (currentRoute[0].breadcrumbs && currentRoute[0].breadcrumbs.length > 0) {
        return currentRoute[0].breadcrumbs.join(' > ');
      }

      // Auto-generate breadcrumbs for settings sub-pages
      if (pathname.startsWith('/settings/') && pathname !== '/settings') {
        const settingsCard = SETTINGS_CARDS.find((card) => card.path === pathname);

        if (settingsCard) {
          return `Settings > ${settingsCard.label}`;
        }
      }

      return currentRoute[0].label;
    }

    // Fallback: Auto-generate breadcrumbs for settings sub-pages even if not in routePathOptions
    if (pathname.startsWith('/settings/') && pathname !== '/settings') {
      const settingsCard = SETTINGS_CARDS.find((card) => card.path === pathname);

      if (settingsCard) {
        return `Settings > ${settingsCard.label}`;
      }
    }

    return '';
  }, [pathname, search]);

  const currentRoute = getCurrentRoute();
  const showBack = useMemo(() => {
    if (currentRoute.length > 0 && currentRoute[0].showBackIcon) {
      return true;
    }
    // Show back button for settings sub-pages

    // if (pathname.startsWith('/settings/') && pathname !== '/settings') {
    //   return true;
    // }

    return false;
  }, [currentRoute, pathname]);

  return (
    <Container>
      <div className="title-container">
        {showBack && (
          <IconWrapper
            onClick={() => {
              if (enableHeaderBackButton) {
                // Use previousUrl from route config if available
                if (currentRoute.length > 0 && currentRoute[0].previousUrl) {
                  navigate(currentRoute[0].previousUrl);
                } else if (pathname.startsWith('/settings/') && pathname !== '/settings') {
                  // Navigate to settings page if on a settings sub-page without previousUrl
                  navigate('/settings');
                } else {
                  navigate(-1);
                }
              }
            }}
          >
            <IoChevronBackOutline id="header-back-icon" />
          </IconWrapper>
        )}
        <Text size="xl" fontWeight={700}>
          {getHeaderTitle}
        </Text>
      </div>
      {!isLoading && (
        <HeaderInfo className=" cursor-pointer" onClick={() => navigate('/editprofile')}>
          <Circle>
            <img src={listData?.admin_tailor_profile_pic_url} alt="profile-pic" />
          </Circle>
          <Text fontWeight={600}>{listData?.admin_tailor_name}</Text>
        </HeaderInfo>
      )}
    </Container>
  );
};

export default Header;
